import { render, staticRenderFns } from "./filogix-container.vue?vue&type=template&id=378ab0c8"
import script from "./filogix-container.vue?vue&type=script&lang=js"
export * from "./filogix-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports